import {confJson} from "@/app/config/confJson";
import KitAPI from "@/Fwk/Kit/KitAPI";

//支持多种 HTTP 方法
export type HttpMethod = "GET" | "POST" | "PUT" | "PATCH" | "DELETE";

//支持加密类型
export type EncryptionType = "RSA" | "noe" | "Binary";

// 定义请求配置的类型接口，包含常见的请求配置项
export interface HttpConfig {
    requestCount?: number; // 当前相对路径请求可请求次数 0 无限制。1=1次 2=2次
    url: string; // 请求的相对路径
    baseUrl?: string;
    method?: HttpMethod;
    headers?: {
        [key: string]: string;
    };
    body?: any;
    timeout?: number;
    retry?: number;
    retryDelay?: number;
    signal?: AbortSignal;
    isToken?: boolean;
    isMergeBody?: boolean;
    isBasic?: boolean;

    //是否强制请求。有提示内容
    isForce?: boolean;

    //是否提示错误信息
    isSerErrTips?: boolean;

    //加密类型默认RSA。 "RSA" | "noe" | "Binary"
    encryptionType?: EncryptionType;
}

//定义接口通用返回参数
export interface HttpResponse<T = any> {
    code: number;
    message: string;
    data: T;
    etag:string;
    description:string;
    timestamp:number;
}

// 定义默认配置
export const defaultConfig: Omit<HttpConfig, 'url'> = {
    requestCount: 1,
    encryptionType: process.env.NODE_ENV === 'development' ? 'noe' : 'RSA',
    baseUrl: confJson.game_api_url,
    method: 'GET',
    headers: {
        'Content-Type': 'application/json',
    },
    body: null,
    timeout: 5000, // 超时10秒
    retry: 0,
    retryDelay: 1000, // 1秒
    isToken: true,
    isMergeBody: true,
    isBasic: true,//是否增加基础的basic
    isForce: false,
    isSerErrTips: false,
};

// 默认请求体
export const defaultRequestBody:any = {
    requestData:{},
    "request_data": {
    },
    "sign": "",
    "timestamp": 0
};

export function getHeaderBasic() {
    return {
        basic:KitAPI.GetHeader().jObject
        // basic:{}
    };
}